import { isBefore, parseISO } from 'date-fns'
import { BountyDetailQuery } from '../../../generated/backendGraphql'

export const shouldShowExpirationExtensionButton = (
  bounty: BountyDetailQuery['bounty'],
) => {
  return (
    bounty.extensionInformation?.availableToExtendBounty ||
    (bounty.extensionInformation?.availableToExtendBounty === false &&
      bounty.extensionInformation.reason === 'STORE_OVER_MONTHLY_SPEND_BUDGET')
  )
}

export const isAvailableToExtendBountyDateValid = (
  availableToExtendDate: string | null | undefined,
) => {
  return (
    availableToExtendDate &&
    isBefore(parseISO(availableToExtendDate), new Date())
  )
}
